"use client";

import { SWRConfig } from "swr";

export { SWRConfig };
